import styled from 'styled-components';

export const StyledSection = styled.section`
  background-image: url('https://crehana-vercel-images-prd.imgix.net/public/02b749dc-2426-4151-91c7-4982c6495317-banner-(1).png?auto=format&fit=clip');
  padding-bottom: 290px;
  background-size: auto 250px;
  background-position: bottom center;

  ${({ theme }) => theme.breakpoints.up('md')} {
    background-size: auto 100%;
    background-position: bottom right;
    padding-bottom: 90px;
    padding-top: 90px;
    max-width: 1366px;
    margin: auto;
  }
`;

export const StyledH4 = styled.h4`
  max-width: 500px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 400px;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    max-width: 500px;
  }
`;
